import React from "react";

import classnames from "classnames";
import leighPhoto from "images/leigh.jpg";
import PropTypes from "prop-types";

type Props = {
  size?: string;
  src: string;
};
export const Avatar = ({ size, src }: Props) => {
  return <img src={src} className={`Avatar Avatar--size_${size}`} />;
};
export const AgentImg = ({ size = "medium", rounded = true, classes }) => {
  const classNames = classnames("AgentImg__img", classes);
  return <Avatar src={leighPhoto} size={size} className={classNames} />;
};
AgentImg.propTypes = {
  size: PropTypes.oneOf(["tiny", "small", "medium", "large"]),
  rounded: PropTypes.bool,
};

export default AgentImg;
